import React, { useRef, useEffect } from 'react';
import './Boots.scss';
import videomov from '../../../../assets/contemporary/boots/contemporary_boots.mov';
import video from '../../../../assets/contemporary/boots/contemporary_boots.webm';
import poster from '../../../../assets/contemporary/boots/contemporary_boots_poster.png';

function ContemporaryBoots() {
  const videoRef = useRef();

  useEffect(() => {
    const videoCurrent = videoRef.current;

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry['isIntersecting'] === true) {
            if (entry['intersectionRatio'] > 0.6) {
              videoCurrent.play();
            }
          }
        });
      },
      { threshold: [0, 0.6] }
    );
    observer.observe(videoCurrent);
  }, []);

  return (
    <section className="boots boots-contemporary">
      <div className="boots__animation boots__animation-contemporary">
        <video
          muted
          playsInline
          preload="auto"
          ref={videoRef}
          className="boots__animation__video"
          poster={poster}
        >
          <source src={videomov} type="video/quicktime" />
          <source src={video} type="video/webm" />
        </video>
      </div>
      <div className="boots__text boots__text-contemporary">
        <h3 className="boots__text__title">
          EMU boots currently come in two sizes — Small and Large — with three possible fit-related
          inserts for each.
        </h3>
        <p className="boots__text__copy">
          A 2004 study of EMU spacesuit training found that astronauts’ feet are often squished. In
          addition to optimizing fit, the study recommended that astronauts make sure there are no
          folds in their socks.
        </p>
      </div>
    </section>
  );
}

export default ContemporaryBoots;
